import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CountUpDirective } from './directives/count-up.directive';
import { MagneticDirective } from './directives/magnetic.directive';
import { OdometerDirective } from './directives/odometer.directive';
import { ParallaxDirective } from './directives/parallax.directive';
import { RevealDirective } from './directives/reveal.directive';
import { SplitTextDirective } from './directives/split-text.directive';
import { TiltDirective } from './directives/tilt.directive';
import { NightDriveComponent } from './night-drive/night-drive.component';

const DECLARATIONS = [
  RevealDirective,
  SplitTextDirective,
  ParallaxDirective,
  TiltDirective,
  MagneticDirective,
  OdometerDirective,
  CountUpDirective,
  NightDriveComponent,
];

@NgModule({
  declarations: DECLARATIONS,
  imports: [CommonModule],
  exports: DECLARATIONS,
})
export class MotionModule {}
